            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate >  
        <b-row style="width:100%">
          <b-col sm="12">
            <b-row  class="row-inputs">
              <sw-inputs
                inputTabla="afiliado_inclusiones"
                inputCampo="radicado"
                :cols="12" :lg="3">
              </sw-inputs>
              <sw-inputs
                inputTabla="afiliado_inclusiones"
                inputCampo="observacion"
                :cols="12"  :lg="4">
              </sw-inputs>
              <sw-inputs
                inputTabla="afiliado_inclusiones"
                inputCampo="archivo_radicado"
                :cols="12"  :lg="4">
              </sw-inputs>
            </b-row>
          </b-col>
        </b-row>  
      </b-form>    
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
            <sw-saveform
              :index="dataIndex[namePath]"
              nameBtn="Radicado"
              :invalid="invalid"
              @save="save"
              >
            </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState, mapActions } from "vuex"
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    SwSaveform
  },
  props: {
    nameInactive: {
      type: String,
      default: ''
    }
  },
  computed: {    
    ...mapState({
    })
  },
  async created()
  {
    
    const await1 = this.updateDataForm({ state: 'afiliado_inclusiones',data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].afiliado_inclusiones})
    const await2 = this.updateDataForm({ state: 'afiliado_inclusiones/archivo_radicado',data: []})
    await await1
    await await2
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  async destroyed(){
    await this.resetDataForm()
  },
  methods: {
    save(emit)
    {
      this.$emit('save', { save: emit.save, ftn: 'radicadoInclusionFtn'})
    },
  }
}
</script>
<style>
</style>